"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.P1 = exports.H3 = exports.H2 = void 0;

var _baseui = require("baseui");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var H2 = (0, _baseui.styled)('h2', function (_ref) {
  var $theme = _ref.$theme;
  var breakpoints = $theme.breakpoints,
      colors = $theme.colors,
      sizing = $theme.sizing,
      typography = $theme.typography;
  return _objectSpread({}, typography.font550, _defineProperty({
    color: colors.colorTertiary,
    marginTop: sizing.scale300,
    marginBottom: sizing.scale300
  }, "@media screen and (min-width: ".concat(breakpoints.medium, "px)"), _objectSpread({}, typography.font750, {
    marginTop: sizing.scale700,
    marginBottom: sizing.scale800
  })));
});
exports.H2 = H2;
var H3 = (0, _baseui.styled)('h3', function (_ref2) {
  var $theme = _ref2.$theme;
  var colors = $theme.colors,
      sizing = $theme.sizing,
      typography = $theme.typography;
  return _objectSpread({}, typography.font550, {
    color: colors.colorSecondary,
    fontWeight: 'bold',
    marginBottom: sizing.scale400
  });
});
exports.H3 = H3;
var P1 = (0, _baseui.styled)('p', function (_ref3) {
  var $theme = _ref3.$theme;
  var breakpoints = $theme.breakpoints,
      colors = $theme.colors,
      typography = $theme.typography;
  return _objectSpread({}, typography.font300, _defineProperty({
    color: colors.mono200
  }, "@media screen and (min-width: ".concat(breakpoints.medium, "px)"), _objectSpread({}, typography.font400)));
});
exports.P1 = P1;